import { useEffect } from "react";

/**
 * Injects a JSON-LD structured-data block for the current route and removes it
 * on unmount/update. Helps Google understand and richly index the page.
 */
export default function JsonLd({ id = "route-jsonld", data }) {
  useEffect(() => {
    if (!data) return undefined;
    const prev = document.getElementById(id);
    if (prev) prev.remove();
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      const cur = document.getElementById(id);
      if (cur) cur.remove();
    };
  }, [id, data]);
  return null;
}
